module.exports = __webpack_public_path__ + "static/media/pl.1b9768ef.svg";